// extracted by mini-css-extract-plugin
export default {"title":"c39386b79b","inner_title":"_02da24a0d7","charge_btn":"_4aeb1b5a2e"};